import { render, staticRenderFns } from "./operation_dic_list.vue?vue&type=template&id=658fabed"
import script from "./operation_dic_list.vue?vue&type=script&lang=js"
export * from "./operation_dic_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports